// Copyright (c) StrangeBee 2023

import { Spin } from 'antd';
import React from 'react';

import './WidgetLoading.scss';

export const WidgetLoading = () => {
    return (
        <div className="widget-loading">
            <Spin />
        </div>
    );
};
